<template>
  <div class="apo">
    <!-- <img src="/favicon.ico" alt="" /> -->
    <div class="aa">
      <div style="margin-top: 20px; font-size: 18px; font-weight: 1000">
        <span
          style="
            padding-bottom: 10px;
            width: 100px;
            border-bottom: 2px solid #00b2ff;
          "
        >
          官方实名
        </span>
      </div>
      <div style="margin-top: 50px">
        <van-form @submit="onSubmit">
          <van-field
            v-model="value"
            name="用户名"
            style="
              border-radius: 5px;
              width: 90%;
              margin-left: 5%;
              padding: 10px;
              background-color: #eeeeee;
            "
            autocomplete="on"
            placeholder="请输入您的卡号"
          />

          <div style="margin: 16px">
            <van-button
              block
              type="info"
              native-type="submit"
              style="width: 100%; margin-top: 30px; border-radius: 10px"
            >
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
    <van-popup
      style="width: 80%"
      round
      :close-on-click-overlay="false"
      v-model="showes"
      closeable
    >
      <div style="margin-top: 20px; font-size: 18px">实名登记</div>
      <p style="font-size: 15px">请使用这个卡号进行实名</p>
      <div
        v-if="fom.realNameCard"
        style="
          margin: 10px;
          border-radius: 10px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
        "
      >
        <input
          id="036"
          v-model="fom.realNameCard"
          readonly
          style="
            text-align: center;
            font-size: 17px;
            width: 75%;
            margin: 10px auto;
            border: 0;
          "
          type="text"
        />
        <span
          @click="copy(fom.realNameCard)"
          style="color: #1890ff; font-size: 13px"
        >
          复制
        </span>
      </div>
      <div
        style="
          margin: 10px;
          border-radius: 10px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
        "
      >
        <input
          id="hao"
          v-model="fom.iccId"
          readonly
          style="
            text-align: center;
            font-size: 17px;
            width: 75%;
            margin: 10px auto;
            border: 0;
          "
          type="text"
        />
        <span
          @click="copy(fom.iccId)"
          v-if="fom.realNameCard"
          style="color: #1890ff; font-size: 13px"
        >
          复制
        </span>
      </div>

      <van-button
        v-if="fom.realNameCard"
        @click="copys"
        style="width: 80%; margin: 10px auto"
        round
        type="info"
      >
        实名
      </van-button>
      <van-button
        v-else
        @click="copys"
        style="width: 80%; margin: 10px auto"
        round
        type="info"
      >
        一键复制去实名
      </van-button>
    </van-popup>
  </div>
</template>

<script>
  import { phoneSimCards } from "@/api/cardOperation";
  import { realAddress, getThirdPartyUrl } from "@/api/user/index.js";
  import { clientGets } from "../api/seting/index";
  export default {
    data() {
      return {
        value: "",
        fom: {},
        showes: false,
        realurl: "",
      };
    },
    created() {},
    async mounted() {},
    methods: {
      onSubmit() {
        this.phoneSimCard();
      },
      phoneSimCard() {
        phoneSimCards(this.value).then((res) => {
          if (res.status) {
            this.fom = res.data;
            this.url();
            this.real();
          }
        });
      },
      copy(val) {
        let input = document.createElement("input");
        input.value = val;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      },
      copys() {
        if (this.fom.seriesModel.realNameType != 4) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            if (this.fom.realNameCard) {
              this.copy(this.fom.realNameCard);
              this.copy(this.fom.iccId);
            } else {
              this.copy(this.fom.iccId);
            }
          } else {
            if (this.fom.realNameCard == undefined) {
              this.copy(this.fom.iccId);
            }
          }
        }

        if (this.fom.seriesModel.realNameType == 2) {
          window.location.href = `https://ec.iot.10086.cn/authApi/service/wx/realnameH5/stepOne?channelId=RNFORWEB&iccid=${this.fom.iccId}&msisdn=${this.fom.realNameCard}`;
        } else if (this.fom.seriesModel.realNameType == 1) {
          console.log("s");
        } else if (this.fom.seriesModel.realNameType == 3) {
          console.log("s");
        } else if (this.fom.seriesModel.realNameType == 4) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          realAddress(this.fom.meCardNum)
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
            });
        } else if (this.fom.seriesModel.realNameType == 5) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          getThirdPartyUrl(this.fom.meCardNum)
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
            });
        } else {
          window.location.href = this.realurl;
        }
      },
      url() {
        clientGets(this.value).then((res) => {
          if (res.status) {
            if (res.data) {
              this.realurl = res.data.realName;
            }
          }
        });
      },
      real() {
        if (this.fom.seriesModel.realNameJudge == 0) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            this.copys();
          } else {
            this.showes = true;
          }
        } else if (
          this.fom.seriesModel.realNameJudge == 1 &&
          this.fom.officialRealName != 0
        ) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            this.copys();
          } else {
            this.showes = true;
          }
        } else if (
          this.fom.seriesModel.realNameJudge == 1 &&
          this.fom.officialRealName == 0
        ) {
          this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
        } else if (this.fom.seriesModel.realNameJudge == 2) {
          if (this.fom.isPay == true && this.fom.officialRealName != 0) {
            if (this.fom.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.showes = true;
            }
          } else if (this.fom.isPay == false) {
            this.$toast.fail("该卡未充值，请充值后再进行官方实名");
          } else if (this.fom.isPay == true && this.fom.officialRealName == 0) {
            this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
          }
        } else if (this.fom.seriesModel.realNameJudge == 3) {
          if (
            this.fom.isPay == true &&
            this.fom.officialRealName != 0 &&
            this.fom.isTheMonth == true
          ) {
            if (this.fom.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.showes = true;
            }
          } else if (this.fom.officialRealName == 0) {
            this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
          } else {
            this.$toast.fail("没有有效期订单，不允许官方实名");
          }
        } else if (this.fom.officialRealName == 0) {
          this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
        } else {
          this.$toast.fail("请联系管理员");
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .apo {
    background: url("../assets/微信图片_20211019140434.jpg") no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    width: 100%;
    height: 100vh;
    padding: 70% 20px;
    box-sizing: border-box;
    // background-size: 100%;
  }

  .aa {
    padding: 10px;
    border-radius: 20px;
    background: white;
  }
</style>
